import { useEffect, useRef } from "react";

export default function NepaliDatepicker({ value, onChange }) {
  const inputRef = useRef();

  useEffect(() => {
    if (window.$ && window.$.nepaliDatePicker) {
      window.$(inputRef.current).nepaliDatePicker();

      window.$(inputRef.current).on("dateChange", (e) => {
        onChange(e.target.value);
      });
    }
  }, []);

  return (
    <input
      type="text"
      ref={inputRef}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder="Enter Nepali date"
      style={{
        width: "320px",
        maxWidth: "100%",
        padding: "12px 16px",
        fontSize: "1rem",
        borderRadius: "8px",
        border: "2px solid #ccc",
        marginBottom: "16px",
        textAlign: "center"
      }}
      autoComplete="off"
    />
  );
}
